import React, { useState, forwardRef, useContext, useEffect } from "react";
import Moment from "moment";
import { StateContext } from "../index";
import AddKookKlussenEerstejaars from "./addKookKlussenEerstejaars";
import PdfKlussenEerstejaars from "./../pdfKlussenEerstejaars";
import { addLog, incrementSjaars } from "../helpers";

import MaterialTable from "material-table";
import { makeStyles } from "@material-ui/core/styles";
import Fab from "@material-ui/core/Fab";
import AddBox from "@material-ui/icons/AddBox";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import AddIcon from "@material-ui/icons/Add";

import firebase from "firebase";

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowUpward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

const useStyles = makeStyles((theme) => ({
  buttons: {
    display: "flex",
    marginTop: theme.spacing(1),
    justifyContent: "space-between",
  },

  addrenter: {
    color: "white",
    margin: theme.spacing(1),
  },
}));

const deleteKookKlussenEerstejaars = (rowData, context) => {
  firebase
    .firestore()
    .collection("kook-eerstejaars" + context.state.year)
    .doc(rowData.id)
    .delete();
  firebase
    .firestore()
    .collection("kook-indeling" + context.state.year)
    .where("klus", "==", rowData.id)
    .get()
    .then((snapshot) => {
      snapshot.forEach((doc) => {
        incrementSjaars(
          doc.data().eerstejaars,
          "kookklussen",
          -1,
          context.state.year
        );
        addLog(
          doc.data().eerstejaars,
          "delete",
          "Verwijdert van kookklus: " + rowData.naam,
          true,
          rowData.id,
          rowData.naam,
          context.state.year
        );
        doc.ref.delete();
      });
    });
};

const KookKlussenEerstejaars = ({ sjaars, indeling, klussen }) => {
  const classes = useStyles();
  const context = useContext(StateContext);

  const [add, setAdd] = useState(null);
  const [value, setValue] = useState([]);
  // const [value, loading, error] = useCollectionData(
  //   firebase.firestore().collection("kook-eerstejaars"),
  //   { idField: "id" }
  // );
  // if (error) return error;
  useEffect(() => {
    const tableValues = [];
    klussen.forEach((doc) => {
      const found = indeling.filter((s) => s.klus === doc.id);
      const voltooid = found.filter((item) => item.voltooid === true).length;
      const boete = found.filter((item) => item.boete === true).length;
      const obj = { voltooid: voltooid, boete: boete };
      tableValues.push({ ...doc, ...obj });
    });
    setValue(tableValues);
    return () => {};
  }, [klussen, indeling]);

  return (
    <>
      <MaterialTable
        isLoading={value === []}
        title="Eerstejaars Kookklussen"
        onRowClick={(event, rowData) =>
          context.actions.setKookKlus({ id: rowData.id, naam: rowData.naam })
        }
        columns={[
          { title: "Klus", field: "naam" },
          {
            title: "Datum",
            field: "datum",
            type: "datetime",
            render: (row) => Moment(row.datum.seconds * 1000).format("LL"),
          },
          {
            title: "Van",
            field: "van",
            type: "datetime",
            defaultSort: "desc",
            render: (row) => Moment(row.van.seconds * 1000).format("LT"),
          },
          {
            title: "Tot",
            field: "tot",
            type: "datetime",
            render: (row) => Moment(row.tot.seconds * 1000).format("LT"),
          },
          { title: "Voltooid", field: "voltooid" },
          { title: "Boete", field: "boete" },
        ]}
        data={value}
        actions={[
          {
            icon: () => <DeleteOutline />,
            tooltip: "Verwijder Kookklus",
            onClick: (event, rowData) => {
              if (
                window.confirm(
                  "Weet je zeker dat je deze klus wilt verwijderen? (dit kan niet ongedaan gemaakt worden)"
                )
              )
                deleteKookKlussenEerstejaars(rowData, context);
              context.actions.setKookKlus(null);
            },
          },
        ]}
        options={{
          pageSize: 20,
          pageSizeOptions: [20, 50, 200],
          emptyRowsWhenPaging: false,
          actionsColumnIndex: -1,
          rowStyle: (rowData) =>
            context.state.selectedKookKlus &&
            context.state.selectedKookKlus.id === rowData.id
              ? { backgroundColor: "#EEE" }
              : {},
        }}
        icons={tableIcons}
        localization={{
          toolbar: { searchPlaceholder: "Zoeken" },
        }}
      />
      <div className={classes.buttons}>
        <PdfKlussenEerstejaars
          collection="kook"
          title="KOOKKLUSSEN"
          months={context.state.months}
        />
        <Fab
          color="primary"
          aria-label="add"
          className={classes.addrenter}
          onClick={() => setAdd(true)}
        >
          <AddIcon />
        </Fab>
      </div>
      <AddKookKlussenEerstejaars id={add} setId={setAdd} sjaars={sjaars} />
    </>
  );
};

export default KookKlussenEerstejaars;
